var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatarepresentation09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 188.9 189.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{opacity:0.4;mix-blend-mode:multiply;}.cls-5{fill:#91181d;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:#f4b331;}.cls-8{fill:#fff;opacity:0.3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-924.27-570.15h798a22.85,22.85,0,0,1,22.85,22.85v312.9A20.41,20.41,0,0,1-123.82-214H-924.27a20.41,20.41,0,0,1-20.41-20.41V-549.74A20.41,20.41,0,0,1-924.27-570.15Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 47.1,
    y1: -37.31,
    x2: 131.9,
    y2: 215.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f46531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f46e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f48631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f4ad31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4e795"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.13,97.05A84.8,84.8,0,0,1,45.77,166.57a82.4,82.4,0,0,1-7.3-5.72A84.74,84.74,0,0,1,10.85,112,84.87,84.87,0,0,1,94.33,12.25h1a84.52,84.52,0,0,1,32.45,6.86A85,85,0,0,1,168.1,55.21,84.35,84.35,0,0,1,179.13,97.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 91.15,
    cy: 93.87,
    r: 81.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 91.15,
    cy: 93.87,
    r: 66.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 93.88,
    cy: 96.6,
    r: 62.27,
    transform: "translate(-40.81 94.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115.52,14.92,29.37,151.56a84.66,84.66,0,0,1-11.1-17L95.38,12.26A84.6,84.6,0,0,1,115.52,14.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.13,23.25,45.77,166.57a82.4,82.4,0,0,1-7.3-5.72L127.83,19.12A85.49,85.49,0,0,1,136.13,23.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatarepresentation09);
export default __webpack_public_path__ + "static/media/Data representation-09.61aead3ca8ebac0aae18ce94aee8632e.svg";
export { ForwardRef as ReactComponent };